import { render } from "./DocumentPage.vue?vue&type=template&id=137599ff&scoped=true&ts=true"
import script from "./DocumentPage.vue?vue&type=script&lang=ts"
export * from "./DocumentPage.vue?vue&type=script&lang=ts"

import "./DocumentPage.vue?vue&type=style&index=0&id=137599ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137599ff"]])

export default __exports__